/**
 * Unique identifier of a post onboarding action.
 */
export var PostOnboardingActionId;
(function (PostOnboardingActionId) {
    PostOnboardingActionId["claimMock"] = "claimMock";
    PostOnboardingActionId["migrateAssetsMock"] = "migrateAssetsMock";
    PostOnboardingActionId["personalizeMock"] = "personalizeMock";
    PostOnboardingActionId["customImage"] = "customImage";
    PostOnboardingActionId["claimNft"] = "claimNft";
    PostOnboardingActionId["assetsTransfer"] = "assetsTransfer";
})(PostOnboardingActionId || (PostOnboardingActionId = {}));
//# sourceMappingURL=postOnboarding.js.map